import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  button {
    min-width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;

    background: linear-gradient(0deg, #f1f3f5, #fff);
    border-color: #cdd4dc;

    border: 1px solid #cbdade;
    border-radius: 4px;
    height: 38px;

    font-size: 14px;
    font-weight: bold;

    transition: background 0.2s;

    svg {
      margin-right: 8px;
    }

    &:hover {
      background: ${shade(0.02, '#f1f3f5')};
    }

    &:active {
      background: ${shade(0.06, '#f1f3f5')};
    }
  }
`;
